export default "__VITE_ASSET__HBp3SzSl__"